import { render } from "./EgmUploadedList.vue?vue&type=template&id=99015a22&scoped=true"
import script from "./EgmUploadedList.vue?vue&type=script&lang=js"
export * from "./EgmUploadedList.vue?vue&type=script&lang=js"

import "./EgmUploadedList.vue?vue&type=style&index=0&id=99015a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99015a22"]])

export default __exports__